"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SKReportType = void 0;
var SKReportType;
(function (SKReportType) {
    SKReportType["TRANSACTIONS"] = "transactions";
})(SKReportType || (exports.SKReportType = SKReportType = {}));
//# sourceMappingURL=SKComplianceModels.js.map